import { CITY_QUERY_PARAM } from 'constants/city';
import { To } from 'react-router-dom';

export const parseCityId = (value: string | null) => {
  if (value == null || value.trim() === '') {
    return null;
  }

  const parsedValue = Number(value);

  if (!Number.isInteger(parsedValue) || parsedValue <= 0) {
    return null;
  }

  return parsedValue;
};

export const buildSearchWithCityId = (
  search: string | URLSearchParams,
  cityId: number | string | null,
) => {
  const nextSearchParams = new URLSearchParams(
    typeof search === 'string' ? search : search.toString(),
  );

  if (cityId == null || cityId === '') {
    nextSearchParams.delete(CITY_QUERY_PARAM);
  } else {
    nextSearchParams.set(CITY_QUERY_PARAM, cityId.toString());
  }

  const searchString = nextSearchParams.toString();

  return searchString ? `?${searchString}` : '';
};

export const withCityId = (to: To, cityId: number | string | null): To => {
  if (cityId == null) {
    return to;
  }

  const id = cityId.toString();

  if (typeof to === 'string') {
    const [pathWithSearch, hash = ''] = to.split('#');
    const [pathname, search = ''] = pathWithSearch.split('?');
    const nextSearch = buildSearchWithCityId(search, id);

    return `${pathname}${nextSearch}${hash ? `#${hash}` : ''}`;
  }

  return {
    ...to,
    search: buildSearchWithCityId(to.search ?? '', id),
  };
};

export const getCityIdFromUrl = () =>
  parseCityId(
    new URLSearchParams(window.location.search).get(CITY_QUERY_PARAM),
  );
